export enum AutoReplyMessageType {
    InitialReply = 'InitialReply',
    ClosedConnectionReply = 'ClosedConnectionReply'
}
